import {Notifier} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";
import {CurrentItem} from "./CurrentItem.js";
import {t} from "../util/Translate.js";

export class CurrentCourse extends CurrentItem {
	static storageItem = "currentCourse";
	static baseRoute = "elearning/frontend/courses";
	static returnProperties = "*,languages[*,language], blocks[*,block[*,languages[*,content,language]]],sections[*]";

	static async readIf(identifier: string) {
		const id = parseInt(identifier);
		let s = JSON.parse(sessionStorage.getItem(CurrentCourse.storageItem)!);

		if (!s || s.id != id) {
			try {
				const result = await ServerApi.single(CurrentCourse.baseRoute, id, CurrentCourse.returnProperties);

				if (result.data) {
					sessionStorage.setItem(CurrentCourse.storageItem, JSON.stringify(result.data));
				}
			} catch (err) {
				Notifier.error(err, 3000);
			}
		}
		return CurrentCourse.get();

	}

	static async load(id: number) {
		CurrentCourse.reset();

		const response = await ServerApi.single(CurrentCourse.baseRoute, id, CurrentCourse.returnProperties);
		if (response.data) {
			sessionStorage.setItem(CurrentCourse.storageItem, JSON.stringify(response.data));
			return CurrentCourse.get();
		}
		throw t("Course not found");
	}

	static get() {
		return JSON.parse(sessionStorage.getItem(CurrentCourse.storageItem)!);
	}

	static reset() {
		sessionStorage.removeItem(CurrentCourse.storageItem);
	}
}

export const currentCourse = () => Object.assign(new CurrentCourse());